module.exports = __webpack_public_path__ + "img/banner5.a6268a8a.png";